/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentNoticeItem } from "./PaymentNoticeItem";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum UserTouchpointEnum {
  "IO" = "IO",

  "CHECKOUT" = "CHECKOUT",

  "CHECKOUT_CART" = "CHECKOUT_CART"
}

export enum UserDeviceEnum {
  "IOS" = "IOS",

  "ANDROID" = "ANDROID",

  "WEB" = "WEB",

  "SAFARI" = "SAFARI"
}

export enum LanguageEnum {
  "IT" = "IT",

  "EN" = "EN",

  "FR" = "FR",

  "DE" = "DE",

  "SL" = "SL"
}

export enum SortByEnum {
  "NAME" = "NAME",

  "DESCRIPTION" = "DESCRIPTION",

  "FEE" = "FEE"
}

export enum SortOrderEnum {
  "ASC" = "ASC",

  "DESC" = "DESC"
}

// required attributes
const PaymentMethodsRequestR = t.interface({
  userTouchpoint: enumType<UserTouchpointEnum>(
    UserTouchpointEnum,
    "userTouchpoint"
  ),

  totalAmount: t.Integer,

  paymentNotice: t.readonlyArray(
    PaymentNoticeItem,
    "array of PaymentNoticeItem"
  )
});

// optional attributes
const PaymentMethodsRequestO = t.partial({
  userDevice: enumType<UserDeviceEnum>(UserDeviceEnum, "userDevice"),

  language: enumType<LanguageEnum>(LanguageEnum, "language"),

  sortBy: enumType<SortByEnum>(SortByEnum, "sortBy"),

  sortOrder: enumType<SortOrderEnum>(SortOrderEnum, "sortOrder"),

  priorityGroups: t.readonlyArray(t.string, "array of string"),

  allCCp: t.boolean,

  targetKey: t.string
});

export const PaymentMethodsRequest = t.intersection(
  [PaymentMethodsRequestR, PaymentMethodsRequestO],
  "PaymentMethodsRequest"
);

export type PaymentMethodsRequest = t.TypeOf<typeof PaymentMethodsRequest>;
